

import state from './moduleLembagaState.js'
import mutations from './moduleLembagaMutations.js'
import actions from './moduleLembagaActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
